const STORAGE_KEY = 'authdata'

function getAuthDataFromStorage() {
  return new Promise((resolve, reject) => {
    if (typeof window.localStorage !== 'undefined') {
      let authData = window.localStorage.getItem(STORAGE_KEY)
      if (authData && authData.indexOf('{') === 0) {
        authData = JSON.parse(authData)
      }
      if (
        typeof authData === 'object' &&
        authData !== null &&
        authData.token &&
        authData.refreshToken
      ) {
        resolve(authData)
      } else {
        reject('no auth data')
      }
    } else {
      // todo: handle for SSR - do backend request for authData
      reject('localStorage not supported')
    }
  })
}

function setAuthDataToStorage(axios, authData) {
  if (typeof window.localStorage !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(authData))
  }
  // else todo: handle for SSR
}

function setAxiosAuthorization(axios, token) {
  axios.defaults.headers.common['x-access-token'] = token
}

function authorize(axios) {
  const postData = {
    name: process.env.VUE_APP_API_AUTH_NAME,
    password: process.env.VUE_APP_API_AUTH_PASSWORD,
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${process.env.VUE_APP_API_PROXY_URL}auth/login`, postData)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.message)
      })
  })
}

function refresh(axios, refreshToken) {
  const postData = {
    name: process.env.VUE_APP_API_AUTH_NAME,
    refreshToken,
  }
  return axios.post(
    `${process.env.VUE_APP_API_PROXY_URL}auth/refresh-token`,
    postData
  )
}

function addAuthTokenInterceptor(axios, authData) {
  let _interceptor = axios.interceptors.response.use(undefined, error => {
    // console.log('*[INTERCEPT]', error)
    const { response } = error
    if (!response) return Promise.reject(error)
    if (response.status === 403 && response.config) {
      if (response.config.__isRetryRequest) {
        return Promise.reject(error)
      }
      return new Promise((resolve, reject) => {
        authorize(axios)
          .then(data => {
            if (!data.token && !data.refreshToken) {
              reject(error)
            } else {
              error.config.__isRetryRequest = true
              error.config.headers['x-access-token'] = data.token
              setAxiosAuthorization(axios, data.token)
              setAuthDataToStorage(axios, {
                token: data.token,
                refreshToken: data.refreshToken,
              })
              axios.interceptors.response.eject(_interceptor)
              _interceptor = addAuthTokenInterceptor(axios, data)
              resolve(axios(error.config))
            }
          })
          .catch(() => {
            reject(error)
          })
      })
    } else if (response.status === 501 && response.config && authData) {
      if (response.config.__isRetryRequest) {
        return Promise.reject(error)
      }
      return new Promise((resolve, reject) => {
        refresh(axios, authData.refreshToken)
          .then(data => {
            error.config.__isRetryRequest = true
            error.config.headers['x-access-token'] = data.token
            setAxiosAuthorization(axios, data.token)
            setAuthDataToStorage(axios, {
              token: data.token,
              refreshToken: data.refreshToken,
            })
            axios.interceptors.response.eject(_interceptor)
            _interceptor = addAuthTokenInterceptor(axios, data)
            resolve(axios(error.config))
          })
          .catch(() => {
            reject(error)
          })
      })
    }
    return Promise.reject(error)
  })
}

function initApiAuth(axios) {
  getAuthDataFromStorage(axios)
    .then(authData => {
      console.log('*[SET AUTH TOKEN]', authData)
      setAxiosAuthorization(axios, authData.token)
      addAuthTokenInterceptor(axios, authData)
    })
    // .catch(error => {
    .catch(error => {
      console.log('*[NO LOCALSTORAGE AUTH KEY]', error)
      if (axios.defaults.headers.common['x-access-token']) {
        delete axios.defaults.headers.common['x-access-token']
      }
      addAuthTokenInterceptor(axios, null)
    })
}

export default initApiAuth
